const server = 'https://jqys-web-ga.racoondigi.cn'
// const server = 'https://jqys-web-ga-pre.racoondigi.cn'
// const server = 'https://jqys-test.racoondigi.cn:8087'
// const server = 'http://localhost:8081'

const wxpubIp = "https://wxpub.racoondigi.cn"

// const appleCallback = 'https://ddf-test.racoondigi.cn:4433'
const appleCallback = 'https://jqys.cn'

// const wechatAuth = 'https://jqhw-download.racoondigi.cn/campaigns_gzip/h5/payment/wechat/pc_wechat/index.html'
// const wechatAuth = 'https://jqhw-download.racoondigi.cn/campaigns_gzip/h5/payment/wechat/pc_wechat_pre/index.html'
const wechatAuth = 'https://jqhw-download.racoondigi.cn/campaigns_gzip/h5/payment/wechat/pc_wechat_pro/index.html'


export default {
    serverIp: server,
    appleCallback: appleCallback,
    wxpubIp: wxpubIp,
    wechatAuth: wechatAuth
}
